import { BranchesInfoContentItem } from "common/BranchesInfo/BranchesInfoContentItem";
import { MdEmail, MdLocationOn, MdPhone } from "react-icons/md";

import "./BranchesInfoPinContent.scss";

type BranchesInfoPinContentProps = {
  title: string;
  address: string;
  phone: string;
  email: string;
  addressLabel: string;
  phoneLabel: string;
  mailLabel: string;
};
export function BranchesInfoPinContent({
  title,
  address,
  phone,
  phoneLabel,
  email,
  addressLabel,
  mailLabel,
}: BranchesInfoPinContentProps) {
  return (
    <>
      <div className="branches-info-pin-content__title">{title}</div>
      {address && (
        <BranchesInfoContentItem
          icon={<MdLocationOn />}
          field={`${addressLabel}`}
          text={address}
        />
      )}
      {phone && (
        <BranchesInfoContentItem
          icon={<MdPhone />}
          field={`${phoneLabel}`}
          text={phone}
        />
      )}
      {email && (
        <BranchesInfoContentItem
          icon={<MdEmail />}
          field={`${mailLabel}`}
          text={email}
        />
      )}
    </>
  );
}
